import { createAction } from 'redux-actions';

export const loadAllTags = createAction('LOAD_ALL_TAGS');
export const loadAllTagsTranslate = createAction('LOAD_ALL_TAGS_TRANSLATE');
export const filterTags = createAction('FILTER_TAGS');
export const paginateTags = createAction('PAGINATE_TAGS');
export const changeSortConfigTag = createAction('CHANGE_SORT_CONFIG_TAG');
